import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';
import { RuleConversationAutomationType } from 'modules/analyse-automations/types/RuleConversationAutomationType';
import {
  RequirementConditionOperator,
  RequirementConditionType
} from 'generated-graphql/types';

// NOTE: This is a workaround to find first matching type that we use in the dropdown
//       This is because the backend returns condition arrays rather than a single object
export const getConversationAutomationTaskType = (
  analysisAutomationItem: AutomationFormItem
): RuleConversationAutomationType => {
  const isConversationScoreCondition =
    analysisAutomationItem.requirementConditions.some((condition) => {
      return condition.type === RequirementConditionType.ConversationScore;
    });

  if (isConversationScoreCondition) {
    return RuleConversationAutomationType.CONVERSATION_SCORE;
  }

  const isConversationStatusCondition =
    analysisAutomationItem.requirementConditions.some((condition) => {
      return (
        condition.type === RequirementConditionType.ConversationStatusCondition
      );
    });

  if (isConversationStatusCondition) {
    return RuleConversationAutomationType.CONVERSATION_STATUS;
  }

  const isConversationMandatoryQuestionsMetCondition =
    analysisAutomationItem.requirementConditions.find((condition) => {
      return (
        condition.type ===
        RequirementConditionType.ConversationMandatoryQuestionsMet
      );
    });

  if (isConversationMandatoryQuestionsMetCondition) {
    if (
      isConversationMandatoryQuestionsMetCondition.operator ===
      RequirementConditionOperator.IsTrue
    ) {
      return RuleConversationAutomationType.CONVERSATION_MANDATORY_QUESTIONS_MET;
    } else {
      return RuleConversationAutomationType.CONVERSATION_MANDATORY_QUESTIONS_NOT_MET;
    }
  }

  return RuleConversationAutomationType.CONVERSATION_MANDATORY_QUESTIONS_MET;
};
